import { DisplayPosition } from '@/type/display-position';
export default {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
        DisplayPosition.cnArrayTable,
    ],
    title: '数字输入框',
    componentName: 'CnNumberPicker',
    getDefaultProps: () => {
        return {
            hideButton: true,
        };
    },
    getPrototypeList: () => {
        return [
            {
                name: 'step',
                title: '步长',
                display: 'inline',
                setter: {
                    componentName: 'NumberSetter',
                    props: {
                        precision: 1,
                    },
                },
            },
            {
                name: 'precision',
                title: '精度（小数点位数）',
                display: 'inline',
                setter: 'NumberSetter',
            },
            {
                name: 'max',
                title: '最大值',
                display: 'inline',
                setter: {
                    componentName: 'NumberSetter',
                    props: {
                        precision: 10,
                    },
                },
            },
            {
                name: 'min',
                title: '最小值',
                display: 'inline',
                setter: {
                    componentName: 'NumberSetter',
                    props: {
                        precision: 10,
                    },
                },
            },
            {
                name: 'innerAfter',
                title: '数字输入框后附加内容',
                display: 'inline',
                setter: 'StringSetter',
            },
            {
                name: 'hideButton',
                title: '是否隐藏左右两侧按钮',
                display: 'inline',
                setter: 'BoolSetter',
            },
        ];
    },
};
